module.exports = __webpack_public_path__ + "img/LebaraActive.0de37b6c.svg";